require('jquery');

var highestZIndex = require('highest-z-index')

module.exports = {
    defaultDelay: 1000,
    rootElement: 'body',
    mask: doMask,
    maskDelayed: doMaskDelayed,
    unmask: doUnmask
};

function doMask(el, delay, withSpinner) {
    el = el || $(module.exports.rootElement)[0];
    if (el.isMasked) {
        return;
    }
    el.isMasked = true;
    var mask = $('.batmask', el);

    if (mask.length === 0) {
        $(el).append('<div class="batmask"></div>');
        mask = $('.batmask', el);
        if (withSpinner) {
            mask.html('<div class="spinner"><img src="/releases/default/assets/images/icons/spinner.svg" /></div>')
        }
        mask.css('z-index', highestZIndex() + 1);
        if (delay) {
            mask.css('opacity', 0);
            el.maskTimeout = setTimeout(function() {
                mask.animate({
                    opacity: 1
                });
            }, delay);
        }
    }
}

function doMaskDelayed(el) {
    doMask(el, module.exports.defaultDelay);
}

function doUnmask(el, force) {
    el = el || $(module.exports.rootElement)[0];
    if (!force && !el.isMasked) {
        return;
    }
    el.isMasked = false;
    clearTimeout(el.maskTimeout);
    delete el.maskTimeout;
    var mask = $('.batmask', el);
    if (mask.length > 0) {
//        mask.stop(false);
        mask.animate({
            opacity: 0
        }, {
            complete: function() {
                mask.remove();
            }
        });
    }
}
